<script>
import Boutton from '../../../component/helper/add/button.vue';
import createService from "./addServicePopup.vue";
import allService from "./allService.vue";

export default {
  components: {
    allService,
    createService,
    Boutton,
  },
  data() {
    return {
      createNewService: false,
      isLoading: false,
    };
  },
  methods: {
    closeCreate(value) {
      if (value) {
        this.isLoading = true;
        console.log(value);
        setTimeout(() => {
          this.isLoading = false;
        }, 10); // 10 ms
      }
      this.createNewService = false
    }
  }
}
</script>

<template>
  <div class="p-6 all">
    <div class="begin">
      <div
        class="content"
      >
        <div class="header flex items-center justify-between mb-12">
          <div class="w-2/3 font-c7 text-left text-c34 2xl:text-c42 text-black">
            Liste des services
          </div>
          <div>
            <Boutton
              label="Ajouter un service"
              weight="500"
              background="#241A72"
              padding="8px 38px"
              size="16"
              @click="createNewService = true"
            />
          </div>
        </div>
        <div class="body">
          <div class="bg-white w-full rounded-10 p-5 min-h-screen">
            <all-service v-if="!isLoading" />
          </div>
        </div>
      </div>
    </div>
    
    <!-- Create new accountant page -->
    <div v-if="createNewService">
      <create-service
        @closeCreate="closeCreate"
        :is-loading="isLoading"
      />
    </div>
  </div>
</template>

<style>
@media (max-width: 1024px) {
  .all {
    padding: 10px;
  }
}
</style>
